<template>
    <div id="tooltip-container" class="d-inline-block">
        <b-button v-on="$listeners" :id="id" :disabled="disabledBtn" variant="primary">
            <b-badge pill variant="light" class="mr-1">{{ count }}</b-badge>
            <strong>{{ $tc('label', getBtnLabel) }}</strong>
        </b-button>
        <b-popover v-if="disabledBtn" target="tooltip-container" triggers="hover" placement="bottom">
            <strong>{{ $tc('tooltip', getTooltipMessage) }}</strong>
        </b-popover>
    </div>
</template>

<script>
export default {
    name: 'ActionBtn',
    inheritAttrs: false,
    props: {
        id: {
            type: String,
            required: true,
        },
        count: {
            type: Number,
            required: true,
            default: 0,
        },
        isUnlink: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    computed: {
        getBtnLabel() {
            return this.isUnlink ? 2 : 1
        },
        getTooltipMessage() {
            return this.isUnlink ? 2 : 1
        },
        disabledBtn() {
            return this.count <= 0
        },
    },
    i18n: {
        messages: {
            'en-US': {
                label: 'Link | Unlink',
                tooltip: 'There is no OKR to link! | There is no OKR to unlink!',
            },
            'en-ES': {
                label: 'Enlace | Desconectar',
                tooltip: '¡No hay OKR para vincular! | ¡No hay OKR para desvincular!',
            },
            'pt-BR': {
                label: 'Vincular | Desvincular',
                tooltip: 'Não há OKR para vincular! | Não há OKR para desvincular!',
            },
        },
    },
}
</script>
